import React from 'react';
import { useHistory } from 'react-router-dom';
import { Box, Button } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import EditMPPointConfigContext from 'contexts/EditMPPointConfigContext';
import MPPointForm from 'forms/MPPointForm';

export default (): JSX.Element => {
  const history = useHistory();
  const { t } = useTranslation();
  const { selectedMPPoint } = React.useContext(EditMPPointConfigContext);
  if (!selectedMPPoint) {
    history.push('/private/admin/payments/mercado-pago-point/posnets');
    return <></>;
  }

  return (
    <div>
      <MPPointForm mpPoint={selectedMPPoint} />
      <Box display="flex" justifyContent="center" width={1}>
        <Button className="btn-50" variant="contained" color="secondary" onClick={() => history.go(-1)}>
          {t('go-back')}
        </Button>
      </Box>
    </div>
  );
};
